module.exports = __webpack_public_path__ + "static/img/envelope-bottom-optimized.942aa21.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/envelope-bottom-optimized.png
// module id = 555
// module chunks = 1